<template>
  <div class="top" :class="type === 'dt' ? 'dt' : ''">
    <div v-if="type === 'ep'" class="txt txtep">
      <p class="txt-p1">免费试用<br />30天无条件退款</p>
      <p class="ft-20">根据场景灵活选配<br />无隐形收费项</p>
    </div>
    <div v-else-if="type === 'dt'" class="txt txtep">
      <p class="txt-p1">高性能云电脑<br/>8核16线程<br/>独享RTX3060显卡</p>
      <p class="ft-20">任意终端，随时随地，为您<br />提供与本地一致的高性能桌面体验</p>
    </div>
    <div v-else class="txt">
      <p class="txt-p1">性能版全新上线<br />支持2k144hz/<br />4k60hz流畅切换</p>
      <p class="ft-20">购买专业版、游戏版或性能版<br />可享受部分商品专属折扣</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="less" scoped>
.top.dt {
  background: url("~@/assets/pricing/pricing_bg_copy@2x.png") no-repeat;
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.txt {
  text-align: center;
  font-size: 32px;
  font-weight: 800;
  line-height: 51px;
  padding-top: 69px;
  padding-bottom: 42px;
  height: 330px;
  box-sizing: border-box;
  .txt-p1 {
    margin-bottom: 10px;
  }
  .ft-20 {
    font-size: 20px;
    line-height: 30px;
  }
}
</style>
